<app-header title="self-serve.payrollSituation.tellUsAboutYourPayrollSituation"></app-header>
<p class="text-color-secondary-font margin-bottom-6">
    {{ 'self-serve.payrollSituation.weWillPersonalizeTrial' | translate }}
</p>
<form #form="ngForm" [class.loading]="isLoading" (ngSubmit)="onSubmit()">
    <div class="responsive-grid">
        <label class="vertical" id="have-run-payroll">{{
            'self-serve.payrollSituation.hasYourCompanyRunPayrollThisYear' | translate
        }}</label>
        <mat-radio-group
            required
            class="vertical"
            aria-labelledby="have-run-payroll"
            name="have-run-payroll"
            #hasRunPayrollThisYear="ngModel"
            [(ngModel)]="selfServeOnboarding.hasRunPayrollThisYear"
            (ngModelChange)="onChangeData()"
        >
            <mat-radio-button [value]="true">{{ 'yes' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false">{{ 'no' | translate }}</mat-radio-button>

            <mat-error *ngIf="form.submitted && hasRunPayrollThisYear.invalid">{{
                'self-serve.fieldRequired' | translate
            }}</mat-error>
        </mat-radio-group>
        <ng-container *ngIf="selfServeOnboarding.hasRunPayrollThisYear">
            <label class="vertical" id="have-current-provider">{{
                'self-serve.payrollSituation.haveCurrentPayrollProvider' | translate
            }}</label>
            <mat-radio-group
                required
                class="vertical"
                aria-labelledby="have-current-provider"
                name="have-current-provider"
                #hasCurrentPayrollProvider="ngModel"
                [(ngModel)]="selfServeOnboarding.hasCurrentPayrollProvider"
                (ngModelChange)="onChangeData()"
            >
                <mat-radio-button [value]="true">{{ 'yes' | translate }}</mat-radio-button>
                <mat-radio-button [value]="false">{{ 'no' | translate }}</mat-radio-button>
                <mat-error *ngIf="form.submitted && hasCurrentPayrollProvider.invalid">{{
                    'self-serve.fieldRequired' | translate
                }}</mat-error>
            </mat-radio-group>
        </ng-container>
        <ng-container *ngIf="selfServeOnboarding.hasCurrentPayrollProvider">
            <label class="vertical">{{ 'self-serve.payrollSituation.whoIsCurrentPayrollProvider' | translate }}</label>
            <mat-form-field>
                <mat-select
                    required
                    name="templateId"
                    #currentPayrollProvider="ngModel"
                    [(ngModel)]="selfServeOnboarding.currentPayrollProvider"
                >
                    <mat-option *ngFor="let provider of payrollProviders" [value]="provider">{{ provider }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.submitted && currentPayrollProvider.invalid">{{
                    'self-serve.fieldRequired' | translate
                }}</mat-error>
            </mat-form-field>

            <ui-banner class="margin-bottom-8" variant="info"
                ><span
                    >{{ 'self-serve.payrollSituation.payrollProviderChange' | translate }}
                    <a target="_blank" href="{{ '4913437438743' | i18nHelpCentre }}">{{
                        'self-serve.payrollSituation.readHelpArticle' | translate
                    }}</a></span
                ></ui-banner
            >
        </ng-container>
    </div>
    <div class="flex buttons justify-end">
        <ui-button type="primary" [submit]="true" [disabled]="isSaving">{{ 'save' | translate }}</ui-button>
    </div>
</form>
